import { createActionCreator } from "common/ReduxUtils";
import { StorageSelectShippingActionTypes } from "../StorageSelectShippingActionTypes";
import { FreightOrderDetails } from "@deliverr/storage-client";

export const setFreightOrderDetails = createActionCreator<Partial<FreightOrderDetails>>(
  StorageSelectShippingActionTypes.STORAGE_SET_FREIGHT_ORDER_DETAILS,
  "freightOrderDetails"
);
